export enum DrawingActionEnum {
    Drawn = 'drawn',
    Undo = 'undo',
    Redo = 'redo',
    Clear = 'clear',
    StateSwitch = 'StateSwitch',
}
